var b = (x, f, i) => new Promise((s, o) => {
  var d = (t) => {
    try {
      u(i.next(t));
    } catch (p) {
      o(p);
    }
  }, n = (t) => {
    try {
      u(i.throw(t));
    } catch (p) {
      o(p);
    }
  }, u = (t) => t.done ? s(t.value) : Promise.resolve(t.value).then(d, n);
  u((i = i.apply(x, f)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getFilenameByResponseHeaders as D, downloadByData as I } from "@oppein/op-utils";
import { postQueryOrderStorageTimeDetailByQry as S } from "../../request/designapi/design/orderStorageTime/queryOrderStorageTimeDetailByQry/post.js";
import { postExportOrderStorageTimeDetail as B } from "../../request/designapi/design/orderStorageTime/exportOrderStorageTimeDetail/post.js";
import { defineComponent as E, useTemplateRef as P, openBlock as V, createElementBlock as j, createElementVNode as v, createVNode as l, withCtx as c, createTextVNode as C, Fragment as L } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as m, reactive as _, unref as r } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import O from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import U from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import F from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import Q from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/pagination/src/Pagination.js";
import z from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const H = { style: { display: "flex", "justify-content": "center", "margin-bottom": "20px" } }, M = { style: { width: "100%", display: "flex", "justify-content": "center", gap: "20px" } }, oe = /* @__PURE__ */ E({
  __name: "deliveryDetails",
  setup(x, { expose: f }) {
    const i = P("deliveryDetailsContainer"), s = m(!1), o = m(!1), d = m([]), n = _({
      businessType: "",
      businessId: "",
      cupboardIdList: []
    }), u = m(3e3), t = _({
      page: 1,
      pageSize: 10,
      itemCount: 0
    }), p = [
      {
        title: "组合柜名称",
        key: "cupboardName",
        align: "center"
      },
      {
        title: "销售编码",
        key: "salesCode",
        align: "center"
      },
      {
        title: "工艺编码",
        key: "technologyCode",
        align: "center"
      },
      {
        title: "物料名称",
        key: "materialName",
        align: "center"
      },
      {
        title: "工厂交货周期",
        key: "storageDayNumber",
        align: "center"
      },
      {
        title: "备注",
        key: "remark",
        align: "center"
      }
    ];
    function N(e, a) {
      Object.assign(n, e), a != null && a.zIndex && (u.value = a.zIndex), s.value = !0, t.page = 1, g();
    }
    function g() {
      return b(this, null, function* () {
        o.value = !0;
        try {
          const e = yield S({
            businessType: n.businessType,
            businessId: n.businessId,
            pageNo: t.page,
            pageSize: t.pageSize,
            cupboardIdList: n.cupboardIdList
          });
          if (!e || !e.data)
            return;
          d.value = e.data.records || [], t.itemCount = e.data.total || 0;
        } catch (e) {
          d.value = [], t.itemCount = 0;
        } finally {
          o.value = !1;
        }
      });
    }
    function k(e) {
      t.page = e, g();
    }
    function w(e) {
      t.pageSize = e, t.page = 1, g();
    }
    const h = () => {
      s.value = !1, d.value = [], t.page = 1;
    }, T = () => b(this, null, function* () {
      o.value = !0;
      try {
        const e = yield B({
          businessType: n.businessType,
          businessId: n.businessId
        }), a = D(e == null ? void 0 : e.headers) || "交期明细.xlsx", y = (e == null ? void 0 : e.headers["content-type"]) || "application/vnd.ms-excel;charset=utf-8";
        e != null && e.data && I(e.data, a, y);
      } catch (e) {
        console.error("导出交期明细异常:", e);
      } finally {
        o.value = !1;
      }
    });
    return f({ open: N }), (e, a) => (V(), j(L, null, [
      v("div", {
        ref_key: "deliveryDetailsContainer",
        ref: i
      }, null, 512),
      l(r(R), {
        bordered: "",
        show: s.value,
        "onUpdate:show": a[0] || (a[0] = (y) => s.value = y),
        "mask-closable": !1,
        "z-index": u.value,
        to: i.value || "body",
        class: "tw:!w-[75%]"
      }, {
        default: c(() => [
          l(r(O), {
            title: "交期明细",
            bordered: !1,
            role: "dialog",
            closable: "",
            onClose: h
          }, {
            default: c(() => [
              l(r(U), { show: o.value }, {
                default: c(() => [
                  l(r(F), {
                    columns: p,
                    data: d.value,
                    pagination: !1,
                    bordered: !0,
                    "single-line": !1,
                    style: { "margin-bottom": "20px" }
                  }, null, 8, ["data"]),
                  v("div", H, [
                    l(r(Q), {
                      page: t.page,
                      "page-size": t.pageSize,
                      "item-count": t.itemCount,
                      "page-sizes": [5, 10, 20, 50],
                      "show-size-picker": "",
                      "onUpdate:page": k,
                      "onUpdate:pageSize": w,
                      to: !1
                    }, null, 8, ["page", "page-size", "item-count"])
                  ])
                ]),
                _: 1
              }, 8, ["show"]),
              v("div", M, [
                l(r(z), {
                  onClick: T,
                  type: "primary"
                }, {
                  default: c(() => a[1] || (a[1] = [
                    C("导出", -1)
                  ])),
                  _: 1,
                  __: [1]
                }),
                l(r(z), { onClick: h }, {
                  default: c(() => a[2] || (a[2] = [
                    C("关闭", -1)
                  ])),
                  _: 1,
                  __: [2]
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show", "z-index", "to"])
    ], 64));
  }
});
export {
  oe as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/com-components/delivery-details/deliveryDetails.vue.js
// module id = 859
// module chunks = 67